// // src/pages/ViewerPage.tsx
// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import { Document, Page } from "react-pdf";
// import DownloadIcon from "@mui/icons-material/Download";
// import {
//   Box,
//   Button,
//   Typography,
//   TextField,
//   CircularProgress,
//   Alert,
// } from "@mui/material";
// import axios from "axios"; 

// import { API_BASE } from "../services/api";

// const ViewerPage: React.FC = () => {
//   const location = useLocation();
//   const searchParams = new URLSearchParams(location.search);

//   // 1. Get Params
//   const fileId = searchParams.get("file_id") || "";
//   const paramAgentId = searchParams.get("agent_id") || ""; 
  
//   // ✅ access_key 확인 (복호화는 백엔드에서 함)
//   const accessKey = searchParams.get("access_key") || ""; 

//   const pageParam = searchParams.get("page");
//   const initialPageRaw = pageParam ? parseInt(pageParam, 10) : 1;
//   const initialPage = Number.isNaN(initialPageRaw) ? 1 : initialPageRaw;

//   // ---- State ----
//   const [numPages, setNumPages] = useState<number>(0);
//   const [renderedPages, setRenderedPages] = useState(0);
//   const [currentPage, setCurrentPage] = useState<number>(initialPage);
//   const [gotoPage, setGotoPage] = useState<number | "">(initialPage);
  
//   const [isLoading, setIsLoading] = useState<boolean>(true);
//   const [pdfBlobUrl, setPdfBlobUrl] = useState<string | null>(null);
//   const [errorMessage, setErrorMessage] = useState<string | null>(null);

//   // Refs
//   const pageRefs = useRef<Array<HTMLDivElement | null>>([]);

//   // ---- Fetch PDF Logic ----
//   useEffect(() => {
//     // 1. file_id 검증
//     if (!fileId) {
//       setErrorMessage("유효하지 않은 파일입니다. (file_id 누락)");
//       setIsLoading(false);
//       return;
//     }

//     const fetchPdf = async () => {
//       setIsLoading(true);
//       setErrorMessage(null);

//       try {
//         const requestConfig: any = {
//             params: {},
//             headers: {},
//             responseType: "blob" // Important: expect binary data
//         };

//         // ✅ [핵심 로직] access_key 유무에 따라 인증 방식 분기
//         if (accessKey) {
//             // Case 1: Marinote에서 넘어온 경우 (Handover)
//             // 로컬 스토리지 검사 없이 access_key를 백엔드로 바로 넘김
//             requestConfig.params.access_key = accessKey;
            
//             // agent_id가 URL에 있으면 같이 보내줌 (보조 정보)
//             if (paramAgentId) {
//                 requestConfig.params.agent_id = paramAgentId;
//             }
//         } else {
//             // Case 2: 일반 접속 (기존 로직)
//             // 로컬 스토리지에서 토큰 확인
//             const userId = localStorage.getItem("user_id") || "";
//             const accessToken = localStorage.getItem("access_token") || "";
//             const refreshToken = localStorage.getItem("refresh_token") || "";

//             if (!userId || !accessToken) {
//                 throw new Error("로그인 정보가 없습니다. 다시 로그인 해주세요.");
//             }

//             requestConfig.headers["x-user-id"] = userId;
//             requestConfig.headers["x-access-token"] = accessToken;
//             requestConfig.headers["x-refresh-token"] = refreshToken;
            
//             // 일반 접속 시엔 agent_id 파라미터가 있으면 보냄
//             if (paramAgentId) {
//                 requestConfig.params.agent_id = paramAgentId;
//             }
//         }

//         // ✅ Call Backend
//         const response = await axios.get(`${API_BASE}files/${fileId}/pdf`, requestConfig);

//         // Create Blob URL
//         const blob = new Blob([response.data], { type: "application/pdf" });
//         const url = URL.createObjectURL(blob);
//         setPdfBlobUrl(url);

//       } catch (err: any) {
//         console.error("PDF fetch error:", err);
//         let msg = "PDF를 불러오는 데 실패했습니다.";
        
//         if (axios.isAxiosError(err)) {
//           if (err.response?.status === 403) {
//             msg = "이 파일에 대한 접근 권한이 없습니다.";
//           } else if (err.response?.status === 404) {
//             msg = "파일을 찾을 수 없거나 아직 변환되지 않았습니다.";
//           } else if (err.response?.status === 401) {
//             msg = "인증이 만료되었거나 유효하지 않습니다.";
//           }
//         } else if (err.message) {
//             msg = err.message;
//         }
//         setErrorMessage(msg);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchPdf();

//     return () => {
//       if (pdfBlobUrl) {
//         URL.revokeObjectURL(pdfBlobUrl);
//       }
//     };
//   }, [fileId, paramAgentId, accessKey]); 

//   // ---- Document Handlers ----
//   const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
//     setNumPages(numPages);
//     setRenderedPages(0);
//     pageRefs.current = Array(numPages).fill(null);
//   };

//   const handlePageRenderSuccess = () => {
//     setRenderedPages((prev) => prev + 1);
//   };

//   // ---- Scroll Sync ----
//   const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
//     const container = event.currentTarget;
//     const containerTop = container.getBoundingClientRect().top;
//     const containerHeight = container.clientHeight;

//     for (let i = 0; i < pageRefs.current.length; i++) {
//       const ref = pageRefs.current[i];
//       if (!ref) continue;
//       const rect = ref.getBoundingClientRect();
//       const relativeTop = rect.top - containerTop;

//       if (relativeTop >= -rect.height / 2 && relativeTop < containerHeight / 2) {
//         setCurrentPage(i + 1);
//         break;
//       }
//     }
//   };

//   // ---- Scroll to Initial Page ----
//   useEffect(() => {
//     if (renderedPages === numPages && numPages > 0) {
//       if (initialPage >= 1 && initialPage <= numPages) {
//         const target = pageRefs.current[initialPage - 1];
//         target?.scrollIntoView({ behavior: "auto" });
//       }
//     }
//   }, [renderedPages, numPages, initialPage]);

//   const jumpToPage = (page: number) => {
//     if (page < 1 || page > numPages) return;
//     const target = pageRefs.current[page - 1];
//     target?.scrollIntoView({ behavior: "smooth" });
//     setCurrentPage(page);
//     setGotoPage(page);
//   };

//   const handleDownload = () => {
//     if (pdfBlobUrl) {
//       const link = document.createElement('a');
//       link.href = pdfBlobUrl;
//       link.download = `document_${fileId}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     }
//   };

//   if (!fileId) {
//     return (
//       <Box sx={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
//         <Alert severity="error">잘못된 접근입니다. (file_id 누락)</Alert>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ position: "relative", height: "100vh", overflow: "hidden", bgcolor: "#f5f5f5" }}>
//       {/* Loading Overlay */}
//       {isLoading && !pdfBlobUrl && !errorMessage && (
//         <Box sx={{ position: "fixed", inset: 0, bgcolor: "rgba(255,255,255,0.8)", zIndex: 2000, display: "flex", justifyContent: "center", alignItems: "center" }}>
//           <CircularProgress />
//         </Box>
//       )}

//       {/* Header */}
//       <Box sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000, bgcolor: "#fff", px: 3, py: 1.5, boxShadow: 1, borderBottom: "1px solid #ddd", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//         <Typography variant="h6" sx={{ fontWeight: "bold", color: "text.primary", display: "flex", gap: 1 }}>
//           📑 Document Viewer
//         </Typography>
//         <Button variant="contained" startIcon={<DownloadIcon />} onClick={handleDownload} disabled={!pdfBlobUrl} size="small">
//           Download
//         </Button>
//       </Box>

//       {/* Error Message */}
//       {errorMessage && (
//         <Box sx={{ mt: "80px", px: 3, display: "flex", justifyContent: "center" }}>
//           <Alert severity="error" sx={{ maxWidth: 600, width: "100%" }}>
//             {errorMessage}
//           </Alert>
//         </Box>
//       )}

//       {/* PDF Content */}
//       <Box onScroll={handleScroll} sx={{ mt: "64px", height: "calc(100vh - 64px - 60px)", overflowY: "auto", px: 2, pb: 4, display: "flex", flexDirection: "column", alignItems: "center" }}>
//         {pdfBlobUrl && !errorMessage && (
//           <Document
//             file={pdfBlobUrl}
//             onLoadSuccess={onDocumentLoadSuccess}
//             loading={<Box sx={{ py: 4, display: "flex", justifyContent: "center" }}><CircularProgress /></Box>}
//             error={<Box sx={{ py: 4, color: "error.main" }}>PDF 렌더링에 실패했습니다.</Box>}
//           >
//             {Array.from({ length: numPages }, (_, index) => (
//               <Box key={`page_${index + 1}`} ref={(el) => { pageRefs.current[index] = el as HTMLDivElement | null; }} sx={{ mb: 4, boxShadow: 3, bgcolor: "white" }}>
//                 <Page pageNumber={index + 1} scale={1.2} renderAnnotationLayer={false} renderTextLayer={false} onRenderSuccess={handlePageRenderSuccess} />
//               </Box>
//             ))}
//           </Document>
//         )}
//       </Box>

//       {/* Footer */}
//       <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000, bgcolor: "#fff", px: 3, py: 1, borderTop: "1px solid #ddd", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//         <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", gap: 1 }}>
//           <Typography variant="body2" sx={{ fontWeight: 600 }}>Page {currentPage} of {numPages || "--"}</Typography>
//         </Box>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//           <TextField
//             size="small" variant="outlined" sx={{ width: 70 }} placeholder="Go" value={gotoPage}
//             inputProps={{ style: { textAlign: "center", padding: "4px" } }}
//             onChange={(e) => {
//               const v = e.target.value;
//               if (v === "") { setGotoPage(""); return; }
//               const n = parseInt(v, 10);
//               if (!Number.isNaN(n)) setGotoPage(n);
//             }}
//             onKeyDown={(e) => { if (e.key === "Enter" && typeof gotoPage === 'number') jumpToPage(gotoPage); }}
//           />
//           <Button variant="outlined" size="small" onClick={() => { if(typeof gotoPage === 'number') jumpToPage(gotoPage); }} disabled={!pdfBlobUrl}>Go</Button>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default ViewerPage;

// src/pages/ViewerPage.tsx
import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Document, Page } from "react-pdf";
import axios from "axios"; 

// UI Components
import {
  Box,
  Typography,
  CircularProgress,
  IconButton,
  Tooltip,
  Paper,
  Divider,
  InputBase,
  Alert
} from "@mui/material";

// Icons
import DownloadIcon from "@mui/icons-material/Download";
import WarningIcon from "@mui/icons-material/Warning";
import ZoomInIcon from "@mui/icons-material/Add";
import ZoomOutIcon from "@mui/icons-material/Remove";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CloseIcon from "@mui/icons-material/Close";

// PDF Styles (Optional depending on setup, but good to include)
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

import { API_BASE } from "../services/api";

const ViewerPage: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // 1. Get Params
  const fileId = searchParams.get("file_id") || "";
  const paramAgentId = searchParams.get("agent_id") || ""; 
  const accessKey = searchParams.get("access_key") || ""; 

  const pageParam = searchParams.get("page");
  const initialPageRaw = pageParam ? parseInt(pageParam, 10) : 1;
  const initialPage = Number.isNaN(initialPageRaw) ? 1 : initialPageRaw;

  // ---- State ----
  const [numPages, setNumPages] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(initialPage);
  const [inputPage, setInputPage] = useState<string>(String(initialPage)); // 입력용 페이지 상태
  
  const [scale, setScale] = useState<number>(1.2); // 줌 상태 (기본 1.2배)
  
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  // Refs
  const pageRefs = useRef<Array<HTMLDivElement | null>>([]);

  // ---- Fetch PDF Logic (DataLake Core) ----
  useEffect(() => {
    if (!fileId) {
      setErrorMessage("유효하지 않은 파일입니다. (file_id 누락)");
      setIsLoading(false);
      return;
    }

    const fetchPdf = async () => {
      setIsLoading(true);
      setErrorMessage(null);

      try {
        const requestConfig: any = {
            params: {},
            headers: {},
            responseType: "blob" 
        };

        // Access Key 분기 로직
        if (accessKey) {
            requestConfig.params.access_key = accessKey;
            if (paramAgentId) requestConfig.params.agent_id = paramAgentId;
        } else {
            const userId = localStorage.getItem("user_id") || "";
            const accessToken = localStorage.getItem("access_token") || "";
            const refreshToken = localStorage.getItem("refresh_token") || "";

            if (!userId || !accessToken) throw new Error("로그인 정보가 없습니다.");
            
            requestConfig.headers["x-user-id"] = userId;
            requestConfig.headers["x-access-token"] = accessToken;
            requestConfig.headers["x-refresh-token"] = refreshToken;
            if (paramAgentId) requestConfig.params.agent_id = paramAgentId;
        }

        const response = await axios.get(`${API_BASE}files/${fileId}/pdf`, requestConfig);
        
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        setPdfBlobUrl(url);

      } catch (err: any) {
        console.error("PDF fetch error:", err);
        let msg = "PDF를 불러오는 데 실패했습니다.";

        // Blob 에러 파싱 (화면에 정확한 에러 표시용)
        if (axios.isAxiosError(err) && err.response) {
            if (err.response.data instanceof Blob) {
                try {
                    const errorText = await err.response.data.text();
                    const errorJson = JSON.parse(errorText);
                    if (errorJson.detail) msg = errorJson.detail;
                } catch (e) {
                    if (err.response.status === 403) msg = "접근 권한이 없습니다.";
                    else if (err.response.status === 404) msg = "파일을 찾을 수 없습니다.";
                }
            } else {
                 if (err.response.status === 403) msg = "접근 권한이 없습니다.";
                 else if (err.response.status === 404) msg = "파일을 찾을 수 없습니다.";
            }
        } else if (err.message) {
            msg = err.message;
        }
        setErrorMessage(msg);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPdf();

    return () => {
      if (pdfBlobUrl) URL.revokeObjectURL(pdfBlobUrl);
    };
  }, [fileId, paramAgentId, accessKey]); 

  // ---- Document Handlers ----
  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
    pageRefs.current = Array(numPages).fill(null);
  };

  // 줌 핸들러
  const handleZoomIn = () => setScale((prev) => Math.min(prev + 0.2, 3.0));
  const handleZoomOut = () => setScale((prev) => Math.max(prev - 0.2, 0.5));

  // 페이지 이동 (스크롤)
  const scrollToPage = (page: number) => {
    if (page < 1 || page > numPages) return;
    pageRefs.current[page - 1]?.scrollIntoView({ behavior: "smooth" });
    setCurrentPage(page);
    setInputPage(String(page));
  };

  // 스크롤 감지
  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const container = event.currentTarget;
    // 화면 중앙에 위치한 페이지 찾기
    for (let i = 0; i < pageRefs.current.length; i++) {
      const ref = pageRefs.current[i];
      if (!ref) continue;
      const rect = ref.getBoundingClientRect();
      // 요소의 상단이 화면의 중간보다 위에 있고, 하단이 중간보다 아래에 있으면 현재 페이지
      if (rect.top >= 0 && rect.top < window.innerHeight / 2) {
         if (currentPage !== i + 1) {
             setCurrentPage(i + 1);
             setInputPage(String(i + 1));
         }
         break;
      }
    }
  };

  // 초기 페이지 이동
  useEffect(() => {
    if (numPages > 0 && initialPage >= 1 && initialPage <= numPages) {
       // 약간의 지연을 두어 렌더링 후 이동
       setTimeout(() => {
          pageRefs.current[initialPage - 1]?.scrollIntoView({ behavior: "auto" });
       }, 500);
    }
  }, [numPages, initialPage]);

  const handleDownload = () => {
    if (pdfBlobUrl) {
      const link = document.createElement('a');
      link.href = pdfBlobUrl;
      link.download = `document_${fileId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  // ---- Render Steps ----

  // 1. Error State
  if (errorMessage) {
     return (
        <Box sx={{ height: "100vh", bgcolor: "#f5f5f5", display: "flex", flexDirection:"column", justifyContent: "center", alignItems: "center", p:3 }}>
          <WarningIcon sx={{ fontSize: 60, color: "text.secondary", mb: 2 }} />
          <Typography variant="h6" fontWeight="bold" color="text.primary">오류 발생</Typography>
          <Alert severity="error" sx={{ mt: 2, maxWidth: 600 }}>{errorMessage}</Alert>
        </Box>
     );
  }

  // 2. Main Viewer
  return (
    <Box sx={{ position: "relative", height: "100vh", overflow: "hidden", bgcolor: "#e0e0e0" }}> {/* 배경 진한 회색 */}
      
      {/* --- Header (Glassmorphism + Dark Text) --- */}
      <Paper 
        elevation={1}
        sx={{
          position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000,
          height: 60, px: 3, display: "flex", alignItems: "center", justifyContent: "space-between",
          bgcolor: "rgba(255, 255, 255, 0.9)", backdropFilter: "blur(8px)", 
          borderBottom: "1px solid rgba(0,0,0,0.05)"
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 800, color: "#333", display: 'flex', alignItems: 'center', gap: 1 }}>
          📑 Document Viewer
        </Typography>

        <Box>
            <Tooltip title="Download PDF">
                <IconButton onClick={handleDownload} disabled={!pdfBlobUrl} sx={{ color: "#333" }}>
                    <DownloadIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title="Close">
                <IconButton onClick={() => window.close()} sx={{ color: "#333" }}>
                    <CloseIcon />
                </IconButton>
            </Tooltip>
        </Box>
      </Paper>

      {/* --- PDF Content --- */}
      <Box
        onScroll={handleScroll}
        sx={{ 
            mt: "60px", 
            height: "calc(100vh - 60px)", 
            overflowY: "auto", 
            px: 2, 
            pb: 15, 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center' 
        }}
      >
        {!pdfBlobUrl && isLoading ? (
             <Box sx={{ height: '80vh', display: 'flex', alignItems: 'center' }}><CircularProgress /></Box>
        ) : (
            <Document
                file={pdfBlobUrl}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={<CircularProgress sx={{ mt: 10 }} />}
                error={<Box sx={{ mt: 10, textAlign: 'center' }}><WarningIcon color="error"/><Typography>Failed to load PDF</Typography></Box>}
            >
            {Array.from({ length: numPages }, (_, index) => (
                <Box 
                key={`page_${index + 1}`} 
                ref={(el: HTMLDivElement | null) => { pageRefs.current[index] = el; }} 
                sx={{ mb: 4, boxShadow: "0 4px 20px rgba(0,0,0,0.15)", borderRadius: 1, overflow: 'hidden' }}
                >
                <Page 
                    pageNumber={index + 1} 
                    scale={scale} 
                    renderTextLayer={false} 
                    renderAnnotationLayer={false}
                />
                </Box>
            ))}
            </Document>
        )}
      </Box>

      {/* --- Floating Control Bar (Dark Capsule) --- */}
      <Paper
        elevation={6}
        sx={{
            position: "fixed", 
            bottom: 30, 
            left: "50%", 
            transform: "translateX(-50%)",
            zIndex: 1100,
            display: "flex", 
            alignItems: "center", 
            gap: 1,
            px: 2, 
            py: 1,
            borderRadius: 100, 
            bgcolor: "rgba(33, 33, 33, 0.9)", // 다크 배경 강제
            backdropFilter: "blur(10px)",
            color: "white" // 텍스트 흰색 강제
        }}
      >
        {/* Zoom Controls */}
        <Tooltip title="Zoom Out">
            <IconButton size="small" onClick={handleZoomOut} sx={{ color: "white" }}>
                <ZoomOutIcon fontSize="small" />
            </IconButton>
        </Tooltip>
        
        <Typography variant="body2" sx={{ minWidth: 40, textAlign: "center", fontWeight: "bold", userSelect: "none", color: "white" }}>
            {Math.round(scale * 100)}%
        </Typography>

        <Tooltip title="Zoom In">
            <IconButton size="small" onClick={handleZoomIn} sx={{ color: "white" }}>
                <ZoomInIcon fontSize="small" />
            </IconButton>
        </Tooltip>

        {/* Divider */}
        <Divider orientation="vertical" flexItem sx={{ bgcolor: "rgba(255,255,255,0.3)", mx: 1, height: 24, alignSelf: 'center' }} />

        {/* Page Navigation */}
        <Tooltip title="Prev Page">
            <IconButton size="small" onClick={() => scrollToPage(currentPage - 1)} disabled={currentPage <= 1} sx={{ color: "white", "&.Mui-disabled": { color: "rgba(255,255,255,0.3)" } }}>
                <NavigateBeforeIcon />
            </IconButton>
        </Tooltip>

        <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: 'rgba(255,255,255,0.1)', borderRadius: 1, px: 1 }}>
            <InputBase
                value={inputPage}
                onChange={(e) => setInputPage(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        const p = parseInt(inputPage, 10);
                        if (!isNaN(p)) scrollToPage(p);
                    }
                }}
                onBlur={() => setInputPage(String(currentPage))}
                sx={{ 
                    color: 'white', // 입력 텍스트 흰색 강제
                    width: 30, 
                    fontSize: '0.9rem', 
                    fontWeight: 'bold',
                    '& input': { textAlign: 'center', p: 0.5 }
                }}
            />
            <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.6)", mr: 0.5 }}>
                / {numPages}
            </Typography>
        </Box>

        <Tooltip title="Next Page">
            <IconButton size="small" onClick={() => scrollToPage(currentPage + 1)} disabled={currentPage >= numPages} sx={{ color: "white", "&.Mui-disabled": { color: "rgba(255,255,255,0.3)" } }}>
                <NavigateNextIcon />
            </IconButton>
        </Tooltip>
      </Paper>

    </Box>
  );
};

export default ViewerPage;